import { createContext, useContext, useState } from "react";
import { Empresa } from "@/interfaces";
import axiosGenerico from "../utils/axiosGenerico";

type EmpresaContextType = {
  empresa: Empresa;
  cargarEmpresa: () => void;
};

const EmpresaContext = createContext<EmpresaContextType>(null!);

const EmpresaProvider = ({ children }: { children: React.ReactNode }) => {
  const [empresa, setEmpresa] = useState<Empresa | null>(() => {
    const storedEmpresa = localStorage.getItem("empresa");
    return storedEmpresa ? JSON.parse(storedEmpresa) : null;
  });

  const cargarEmpresa = async () => {
    await axiosGenerico.get("/empresa").then((res) => {
      setEmpresa(res.data);
      localStorage.setItem("empresa", JSON.stringify(res.data));
    });
  };

  return (
    <EmpresaContext.Provider value={{ empresa, cargarEmpresa }}>
      {children}
    </EmpresaContext.Provider>
  );
};

export { EmpresaContext, EmpresaProvider };

export const useEmpresa = () => useContext(EmpresaContext);
